import { render } from "./EditConfigSkills.vue?vue&type=template&id=4a6ada88"
import script from "./EditConfigSkills.vue?vue&type=script&lang=js"
export * from "./EditConfigSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__